module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-page-organization"
  }, [(_vm.$slots[_vm.slotNames.TOP]) ? _c('div', {
    staticClass: "component-page-organization__top",
    class: _vm.classesTop
  }, [_vm._t(_vm.slotNames.TOP)], 2) : _vm._e(), (_vm.namePosition === _vm.namePositions.TOP) ? _c('h1', {
    staticClass: "component-page-organization__top-title"
  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _c('div', {
    staticClass: "component-page-organization__content"
  }, [_c('div', {
    staticClass: "component-page-organization__sidebar",
    class: _vm.sidebarClasses
  }, [(_vm.logo) ? _c('div', {
    staticClass: "component-page-organization__logo"
  }, [_c('div', {
    staticClass: "component-page-organization__logo-image",
    style: ({
      backgroundImage: ("url(" + _vm.logo + ")")
    })
  })]) : _vm._e(), _c('div', {
    staticClass: "component-page-organization__info"
  }, [_vm._t(_vm.slotNames.SIDEBAR), (_vm.programsLink) ? _c('SidebarElement', {
    attrs: {
      "title": _vm.allProgramsTitle
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.programsLink
    }
  }, [_vm._v("Здесь")])], 1) : _vm._e(), (_vm.isActiveModuleVacancies && _vm.vacanciesLink) ? _c('SidebarElement', {
    attrs: {
      "title": _vm.allVacanciesTitle
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.vacanciesLink
    }
  }, [_vm._v("Здесь")])], 1) : _vm._e(), (_vm.municipality && _vm.municipalityLink) ? _c('SidebarElement', {
    attrs: {
      "title": _vm.municipalityTitle
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.municipalityLink
    }
  }, [_vm._v(_vm._s(_vm.municipality))])], 1) : _vm._e(), (_vm.address) ? _c('SidebarElement', {
    attrs: {
      "title": _vm.addressTitle
    }
  }, [_vm._v(_vm._s(_vm.address))]) : _vm._e(), (_vm.address) ? _c('SidebarElement', {
    attrs: {
      "title": _vm.contactsTitle
    }
  }, _vm._l((_vm.contacts), function(ref) {
    var href = ref.href;
    var text = ref.text;
    var code = ref.code;

    return _c('div', {
      key: code
    }, [_c('a', {
      staticClass: "component-page-organization_place",
      attrs: {
        "href": href
      }
    }, [_vm._v(_vm._s(text))])])
  }), 0) : _vm._e()], 2)]), _c('div', {
    staticClass: "component-page-organization__main",
    class: _vm.mainClasses
  }, [(_vm.$slots[_vm.slotNames.INSIDE]) ? _c('div', {
    staticClass: "component-page-organization__inside"
  }, [_vm._t(_vm.slotNames.INSIDE)], 2) : _vm._e(), (_vm.namePosition === _vm.namePositions.INSIDE) ? _c('h1', {
    staticClass: "component-page-organization__title"
  }, [_vm._v(_vm._s(_vm.name))]) : _vm._e(), _c('div', {
    staticClass: "component-page-organization__slot"
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa39222","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/organization/component.vue
// module id = 32d75ea34a09a11800f1
// module chunks = 0